import React from 'react';
import styled from 'styled-components';
import CookieSettings from '../components/CookieSettings';
import useTranslation from '../hooks/useTranslation';

const PageContainer = styled.div`
  min-height: 100vh;
  background: ${props => props.theme.color.background};
  padding: 40px 20px;

  @media (max-width: 768px) {
    padding: 20px 10px;
  }
`;

const Header = styled.div`
  max-width: 800px;
  margin: 0 auto 40px;
`;

const PageTitle = styled.h1`
  font-size: ${props => props.theme.fontSize.xl};
  font-weight: 700;
  color: ${props => props.theme.color.darkerText};
  margin-bottom: 12px;

  @media (max-width: 768px) {
    font-size: ${props => props.theme.fontSize.lg};
  }
`;

const PageDescription = styled.p`
  font-size: ${props => props.theme.fontSize.sm};
  color: ${props => props.theme.color.lighterText};
  line-height: 1.6;
`;

const LinkText = styled.a`
  color: ${props => props.theme.color.primary};
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const CookieSettingsPage = () => {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <Header>
        <PageTitle>
          🍪 {t('cookie.pageTitle', 'Paramètres des cookies')}
        </PageTitle>
        <PageDescription>
          {t('cookie.pageDescription', 'Configurez vos préférences de cookies pour contrôler comment nous collectons et utilisons vos données. Pour en savoir plus sur notre utilisation des cookies et notre politique de confidentialité, consultez notre')}{' '}
          <LinkText href="/legal/rgpd" target="_blank" rel="noopener noreferrer">
            {t('cookie.privacyPolicy', 'politique de confidentialité')}
          </LinkText>.
        </PageDescription>
      </Header>
      
      <CookieSettings />
    </PageContainer>
  );
};

export default CookieSettingsPage;

